/*
 * @Author: jsZhao
 * @Date: 2017-12-26 17:29:28
 * @Last Modified by: aLeng
 * @Last Modified time: 2018-06-20 10:39:03
 */

 //时间戳转换
 const mainTime = (val)=>{
   let lastTime;
   if(val){
     lastTime = new Date(parseInt(val));

   }else{
     lastTime = new Date();
   }

   let year = lastTime.getFullYear();
   let month = lastTime.getMonth()<9?('0'+(lastTime.getMonth()+1)):(lastTime.getMonth()+1);
   let date = lastTime.getDate()<10?('0'+lastTime.getDate()):(lastTime.getDate());
   let hour = lastTime.getHours();
   let minute = lastTime.getMinutes()<10?('0'+lastTime.getMinutes()):(lastTime.getMinutes());
   let second = lastTime.getSeconds();

   return year+'/'+month+'/'+date+' '+hour+':'+minute;
 }

 const financeTime = (val)=>{
  let lastTime;
  if(val){
    lastTime = new Date(parseInt(val));
  }else{
    lastTime = new Date();
  }

  let year = lastTime.getFullYear();
  let month = lastTime.getMonth()<9?('0'+(lastTime.getMonth()+1)):(lastTime.getMonth()+1);
  let date = lastTime.getDate()<10?('0'+lastTime.getDate()):(lastTime.getDate());
  let hour = lastTime.getHours();
  let minute = lastTime.getMinutes()<10?('0'+lastTime.getMinutes()):(lastTime.getMinutes());
  let second = lastTime.getSeconds();

  return year+'-'+month+'-'+date+' '+hour+':'+minute;
}

/**
 *
 * @param data
 * @returns {Array}
 */
const toTreeData = (m1,m2,m3) => {
  var firstMenuList = new Map();
  let oldFirstMenuList = new Map();
  var secondMenuList = new Map();
  var threeMenuList = new Map();
  for (let i=0,len=m1.length;i<len;i++){
    oldFirstMenuList.set(m1[i].id,m1[i]);
  }

  for (let i=0,len=m2.length;i<len;i++){
    secondMenuList.set(m2[i].id,m2[i]);
  }
  for (let i=0,len=m3.length;i<len;i++){
    threeMenuList.set(m3[i].id,m3[i]);
  }

  let keys = [...oldFirstMenuList.keys()]
  for (let i=0,len = keys.length; i<len-1;i++){
    for(let j=0;j<len -1 -i ;j++){
      if(keys[j]>keys[j+1]){
        let temp = keys[j];
        keys[j] = keys[j+1];
        keys[j+1] = temp;
      }
    }
  }
  // let icons = Array('el-icon-cms-building','el-icon-cms-building','el-icon-cms-building','el-icon-cms-building','el-icon-cms-building','el-icon-cms-building');
  for (let i = 0,len = keys.length;i<len;i++){
    // oldFirstMenuList.get(keys[i]).icon = icons[i];
    firstMenuList.set(keys[i],oldFirstMenuList.get(keys[i]));
  }

  // console.error(firstMenuList);
  // console.error(secondMenuList);
  // console.error(threeMenuList);
  let tree =[];
  for(let item of threeMenuList.entries()){
    if(!secondMenuList.get(item[1].parentId).children){
      secondMenuList.get(item[1].parentId).children = [];

    }
    secondMenuList.get(item[1].parentId).children.push(item[1])
  }
  for(let item of secondMenuList.entries()){
    if(!firstMenuList.get(item[1].parentId).children){
      firstMenuList.get(item[1].parentId).children = [];
    }
    firstMenuList.get(item[1].parentId).children.push(item[1]);
  }
  tree = [...firstMenuList.values()];
  return tree;
}


const toFixed = (number) => {
  number = Number(number);
  if(!number) number = 0;
  return number.toFixed(2);
}

const compareTime = (start,end)=>{
  if(start<=end){
    return true
  }else{
    return false
  }
}

 export {
   mainTime,
   financeTime,
   toTreeData,
   toFixed,
   compareTime,
 }



// WEBPACK FOOTER //
// ./src/utils/index.js